module.exports = __webpack_public_path__ + "static/media/16UNODC36.c8120272.jpg";